/*
===============================================================================================================
                                 Copyright 2025-2025, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

/* eslint-disable no-console */
import apiClient from '@/utilities/api-client';

/**
 * Merchant subBrand API
 * Returns a merchant's subBrand company
 */
export const getMerchantBrand = async ({ merchant, token }) => {
  const authHeaders = {
    headers: {
      Authorization: token,
    },
  };

  try {
    const response = await apiClient.get(`config/companyId/${merchant}/brand`, authHeaders);
    const { subBrand } = response.data.resource;
    return {
      data: { subBrand },
    };
  } catch (error) {
    if (error.response?.status === 401) {
      throw new Error('Unauthorized');
    }
    if (error.response?.status === 400) {
      throw new Error('Bad Request');
    }
    if (error.response?.status === 404) {
      throw new Error('Merchant Not Found');
    }
    throw new Error(error.message);
  }
};

export default getMerchantBrand;
